<template>
    <div class="attr-info-body">
		<p>商品参数</p>
		<el-form
			:model="ruleForm"
			ref="ruleForm"
			class="attr-ruleForm"
			label-position='right'
			label-width="100px"
		>
			<el-form-item label="商品产地：">
				<el-input :disabled="editDisable" v-model="ruleForm.goodsProductPlace" placeholder="请输入商品产地" :maxlength="30"></el-input>
			</el-form-item>
			<el-form-item label="包装清单：">
				<el-input :disabled="editDisable" v-model="ruleForm.packList" placeholder="请输入包装清单" :maxlength="30"></el-input>
			</el-form-item>
			<el-form-item label="保质期：">
				<el-input :disabled="editDisable" v-model="ruleForm.qualityDate" placeholder="请输入保质期" :maxlength="30"></el-input>
			</el-form-item>
			<el-form-item label="厂商名称：">
				<el-input :disabled="editDisable" v-model="ruleForm.venderName" placeholder="请输入厂商名称" :maxlength="30"></el-input>
			</el-form-item>
			<el-form-item label="贮存条件：">
				<el-input :disabled="editDisable" v-model="ruleForm.storage" placeholder="请输入贮存条件" :maxlength="30"></el-input>
			</el-form-item>
			<el-form-item v-if="!producttype" label="运输方式：">
				<el-select :disabled="editDisable" v-model="transportMode" size='mini'>
					<el-option :value='1' label="常温运输"></el-option>
					<el-option :value='2' label="冷链运输"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'attributesInfo',
	props: {
		producttype: Boolean,
		productDetails: {
			type: Array,
			default: () => []
		},
		editDisable: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			transportMode: 1,
			ruleForm: {
				goodsProductPlace: '',
				packList: '',
				qualityDate: '',
				venderName: '',
				storage: '',
				id: sessionStorage.getItem('goodsid')
			}
		}
	},
	watch: {
		productDetails (val) {
			val.forEach(e => {
				switch (e.name) {
				case '商品产地':
					this.ruleForm.goodsProductPlace = e.val
					break
				case '包装清单':
					this.ruleForm.packList = e.val
					break
				case '保质期':
					this.ruleForm.qualityDate = e.val
					break
				case '厂商名称':
					this.ruleForm.venderName = e.val
					break
				case '贮存条件':
					this.ruleForm.storage = e.val
					break
				}
			})
		}
	},
	created () {
		switch (this.productDetails) {
		case 0:
			this.statusIcon = 'submit'
			break
		case 1:
			this.statusIcon = 'pending'
			break
		case 2:
			this.statusIcon = 'pass'
			break
		case 3:
			this.statusIcon = 'reject'
			break
		}
		// this.getGoodsInfo()
	},
	methods: {
		getInfo () {
			return this.ruleForm
		},
		resetForm () {
			this.ruleForm.goodsProductPlace = ''
			this.ruleForm.packList = ''
			this.ruleForm.qualityDate = ''
			this.ruleForm.venderName = ''
			this.ruleForm.storage = ''
		},
		getGoodsInfo () {
			let params = {
				id: sessionStorage.getItem('goodsid'),
				bcId: '0',
				scId: '0',
				goodsName: '',
				saleState: 2,
				auditState: 4,
				page: 1,
				size: 20,
				hiddenFlag: +sessionStorage.getItem('goodHiddenFlag'),
				order: 1,
				orderKey: '',
				unitFlag: -1,
				sourceflag: -1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data.recordList[0]
					this.ruleForm.goodsProductPlace = data.goodsProductPlace
					this.ruleForm.packList = data.packList
					this.ruleForm.qualityDate = data.qualityDate
					this.ruleForm.venderName = data.venderName
					this.ruleForm.storage = data.storage
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.attr-info-body {
	flex: 1
	text-align left
	p {
		height: 20px
		text-align: left
		line-height 20px
		font-size 16px
		border-left 4px solid var(--fx-primary-color)
		padding-left 8px
		margin 20px 0
		// font-weight 700
	}
	.attr-ruleForm {
		.el-form-item {
			margin-bottom 10px
			.el-input {
				width: 460px
			}
		}
	}
}
</style>
